import { render } from "./AdfRecords.vue?vue&type=template&id=3566f1cb&scoped=true"
import script from "./AdfRecords.vue?vue&type=script&lang=js"
export * from "./AdfRecords.vue?vue&type=script&lang=js"

import "./AdfRecords.vue?vue&type=style&index=0&id=3566f1cb&lang=scss"
import "./AdfRecords.vue?vue&type=style&index=1&id=3566f1cb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3566f1cb"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QForm,QInput,QSelect,QIcon,QTooltip,QTable});
